import { useTranslation, Trans } from 'react-i18next'
import useSettings from './useSettings'
// config
import { allLangs, defaultLang } from '../config'
import { getActiveLanguage } from 'helpers/locale'

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t } = useTranslation()

  const { onChangeDirectionByLang } = useSettings()

  // Same resolver the axios layer stamps onto the Language header, so what the
  // user reads and what the BE is asked for cannot disagree.
  const currentLang =
    allLangs.find((_lang) => _lang.value === getActiveLanguage()) ||
    defaultLang

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang)
    onChangeDirectionByLang(newlang)
  }

  return {
    onChangeLang: handleChangeLanguage,
    t: (text: any, options?: any) => t(text, options),
    currentLang,
    allLangs,
    Trans,
  }
}
